module.exports = __webpack_public_path__ + "static/media/dashboard-normal-logo.7e3911b0.svg";